import { useEffect } from "react";

export const useMainAppHeightAdjustment = (deps = []) => {
  const dependencies = Array.isArray(deps) ? deps : [];

  useEffect(() => {
    let classObserver = null;

    const observeClassChanges = dropdownEl => {
      const handleChange = () => {
        const mainEl = document.body;
        const isOpen = dropdownEl.classList.contains("open");
        const isClose = dropdownEl.classList.contains("close");

        if (isOpen && mainEl) {
          const dropdownHeight = dropdownEl.offsetHeight + 16;
          const dropdownElBCR = dropdownEl.getBoundingClientRect();
          const totalMinHeight = Math.min(document.body.offsetHeight, dropdownElBCR.y) + dropdownHeight;
          mainEl.style.minHeight = `${totalMinHeight}px`;
        }

        if (isClose && mainEl) {
          mainEl.style.minHeight = "unset";
        }
      };

      classObserver = new MutationObserver(handleChange);

      classObserver.observe(dropdownEl, {
        attributes: true,
        attributeFilter: ["class"],
      });

      handleChange();
    };

    const waitForDropdownAndObserve = () => {
      const dropdownEl = document.querySelector(".eu-dropdown__popout");
      if (dropdownEl) {
        observeClassChanges(dropdownEl);
        mountObserver.disconnect();
      }
    };

    const mountObserver = new MutationObserver(waitForDropdownAndObserve);

    mountObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    waitForDropdownAndObserve();

    return () => {
      classObserver?.disconnect();
      mountObserver?.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};
